import { FC } from 'react';
import { Box, IconButton } from '@mui/material';
import { RHFAutocomplete, RHFPhoneNumberInput, RHFTextField } from 'src/components';
import Iconify from 'src/components/Iconify';
import { professionsOptions } from 'src/constants';
import { UserProps } from './types';

const User: FC<UserProps> = ({ name, index, isLast, handleDelete }) => (
	<Box
		display='flex'
		gap='10px'
		flexDirection='column'
		pb='10px'
		position='relative'
		{...(!isLast && { borderBottom: '2px solid lightgray' })}
	>
		<IconButton onClick={handleDelete} sx={{ position: 'absolute', top: '-26px', right: '-7px' }}>
			<Iconify icon='zondicons:close-outline' fontSize='16px' />
		</IconButton>
		<Box display='flex' gap='10px'>
			<RHFTextField size='small' name={`${name}.${index}.givenNames`} label='Given names' />
			<RHFTextField size='small' name={`${name}.${index}.lastNames`} label='Last names' />
		</Box>
		<Box display='flex' gap='10px'>
			<RHFTextField size='small' name={`${name}.${index}.email`} label='Email' />
			<RHFPhoneNumberInput size='small' name={`${name}.${index}.phone`} label='Phone number' />
		</Box>
		<RHFAutocomplete
			name={`${name}.${index}.professionId`}
			label='Select profession'
			options={professionsOptions}
			valueAttribute='id'
			size='small'
		/>
	</Box>
);

export default User;
